import Vue from 'vue'
import VueRouter from 'vue-router'
import { isAuthenticated } from '../Utils/auth';
import { isDebug } from '../Utils/account';
/* Layouts */
const VerticleLayout = () => import('../layouts/VerticleLayout')
const VerticalLayout = () => import('../layouts/VerticalLayout')
const Default = () => import('../layouts/BlankLayout')
const AuthLayout = () => import('../layouts/AuthLayouts/AuthLayout')
const HorizantalLayout = () => import('../layouts/HorizantalLayout')
const DemoHorizontalLayout = () => import('../layouts/DemoHorizontalLayout')
/* Dashboards View */
const Dashboard1 = () => import('../views/Dashboards/Dashboard1.vue')
const Dashboard2 = () => import('../views/Dashboards/Dashboard2.vue')
const Dashboard3 = () => import('../views/Dashboards/Dashboard3')
const Dashboard4 = () => import('../views/Dashboards/Dashboard4')
const Dashboard5 = () => import('../views/Dashboards/Dashboard5')
const Dashboard6 = () => import('../views/Dashboards/Dashboard6')
const DashboardDemo = () => import('../views/Dashboards/DashboardDemo')
const Dashboard12 = () => import('../views/Dashboards/Dashboard12.vue')
/* UIElements View */
const UiAlerts = () => import('../views/core/UiAlerts.vue')
const UiButtons = () => import('../views/core/UiButtons.vue')
const UiBadges = () => import('../views/core/UiBadges.vue')
const UiBreadcrumb = () => import('../views/core/UiBreadcrumb.vue')
const UiColors = () => import('../views/core/UiColors.vue')
const UiTypography = () => import('../views/core/UiTypography.vue')
const UiCards = () => import('../views/core/UiCards.vue')
const UiCarousel = () => import('../views/core/UiCarousel.vue')
const UiEmbedVideo = () => import('../views/core/UiEmbedVideo.vue')
const UiGrid = () => import('../views/core/UiGrid.vue')
const UiModal = () => import('../views/core/UiModal.vue')
const UiListGroup = () => import('../views/core/UiListGroup.vue')
const UiImages = () => import('../views/core/UiImages.vue')
const UiMediaObject = () => import('../views/core/UiMediaObject.vue')
const UiTooltips = () => import('../views/core/UiTooltips.vue')
const UiPopovers = () => import('../views/core/UiPopovers.vue')
const UiNotifications = () => import('../views/core/UiNotifications.vue')
const UiTabs = () => import('../views/core/UiTabs.vue')
const UiPagination = () => import('../views/core/UiPagination.vue')
const UiProgressBars = () => import('../views/core/UiProgressBars.vue')
/* Authentic View */
const Login = () => import('../views/AuthPages/Default/Login')
const ResetPassword = () => import('../views/AuthPages/Default/ResetPassword')
const Register = () => import('../views/AuthPages/Default/Register')
const SendResetCode = () => import('../views/AuthPages/Default/SendResetCode')
const SignIn1 = () => import('../views/AuthPages/Default/SignIn1')
const SignUp1 = () => import('../views/AuthPages/Default/SignUp1')
const RecoverPassword1 = () => import('../views/AuthPages/Default/RecoverPassword1')
const LockScreen1 = () => import('../views/AuthPages/Default/LockScreen1')
const ConfirmMail1 = () => import('../views/AuthPages/Default/ConfirmMail1')
const Callback = () => import('../views/AuthPages/Default/Callback')
/* Extra Pages */
const ErrorPage = () => import('../views/Pages/ErrorPage')
const ComingSoon = () => import('../views/Pages/ComingSoon')
const Maintenance = () => import('../views/Pages/Maintenance')
const TimeLine = () => import('../views/Pages/TimeLines')
const Pricing = () => import('../views/Pages/Pricing')
const Pricing1 = () => import('../views/Pages/Pricing1')
const BlankPage = () => import('../views/Pages/BlankPage')
const FAQ = () => import('../views/Pages/FAQ')
const Invoice = () => import('../views/Pages/Invoice')
/* Apps Views */
const EmailListing = () => import('../views/Apps/Email/EmailListing')
const EmailCompose = () => import('../views/Apps/Email/EmailCompose')
const Calendar = () => import('../views/Apps/Calendar/Calendar')
const ECommerceListing = () => import('../views/Apps/Ecommerce/Listing')
const Checkout = () => import('../views/Apps/Ecommerce/Checkout')
const Wishlist = () => import('../views/Apps/Ecommerce/Wishlist')
const EcommerceDetail = () => import('../views/Apps/Ecommerce/Detail')
const ChatIndex = () => import('../views/Apps/Chat/Index')
const ProjectBoard = () => import('../views/Apps/ProjectManagement/ProjectBoard')
/* Icon Views */
const IconDripicons = () => import('../views/Icons/IconDripicons')
const IconFontawesome5 = () => import('../views/Icons/IconFontawesome5')
const IconLineAwesome = () => import('../views/Icons/IconLineAwesome')
const IconRemixicon = () => import('../views/Icons/IconRemixicon')
const IconUnicons = () => import('../views/Icons/IconUnicons')
/* Tables Views */
const TablesBasic = () => import('../views/Tables/TablesBasic')
const EditableTable = () => import('../views/Tables/EditableTable')
/* Charts View */
const ApexCharts = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ApexChart" */ '../views/Charts/ApexCharts')
const AmCharts = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "AmCharts" */'../views/Charts/AmCharts')
const HighCharts = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "HighCharts" */'../views/Charts/HighCharts')
/* Google Map */
const GoogleMaps = () => import('../views/Maps/GoogleMaps')
/* Form View */
const FormLayout = () => import('../views/Forms/FormLayout')
const FormValidates = () => import('../views/Forms/FormValidates')
const FormSwitches = () => import('../views/Forms/FormSwitches')
const FormRadios = () => import('../views/Forms/FormRadios')
const FormCheckboxes = () => import('../views/Forms/FormCheckboxes')
/* User View */
const Profile = () => import('../views/User/Profile')
const ProfileEdit = () => import('../views/User/ProfileEdit')
const AddUser = () => import('../views/User/AddUser')
const UserList = () => import('../views/User/UserList')
/* Apps View */
const SocialApp = () => import('../views/Apps/Social/SocialApp')
const TodoListing = () => import('../views/Apps/Todo/TodoListing')
/* Plugins Views */
const DatepickerDemo = () => import('../views/Plugins/DatepickerDemo')
const SelectDemo = () => import('../views/Plugins/SelectDemo')
const DragDropDemo = () => import('../views/Plugins/DragDropDemo')
const AppTreeView = () => import('../views/Plugins/AppTreeView')
/* Demo */
const Dashboard = () => import('../views/Demo/Dashboard')
const Contacts = () => import('../views/Demo/Contacts')
const ContactsCreate = () => import('../views/Demo/ContactsCreate')
const ContactsDetail = () => import('../views/Demo/ContactsDetail')
const ContactsEdit = () => import('../views/Demo/ContactsEdit')
const Companies = () => import('../views/Demo/Companies')
const CompaniesCreate = () => import('../views/Demo/CompaniesCreate')
const CompaniesEdit = () => import('../views/Demo/CompaniesEdit')
const CompaniesDetail = () => import('../views/Demo/CompaniesDetail')
const Lists = () => import('../views/Demo/Lists')
const ListsCreate = () => import('../views/Demo/ListsCreate')
const ListsCreateAndEdit = () => import('../views/Demo/ListsCreateAndEdit')
const ContactManagement = () => import('../views/Demo/ContactManagement')
const ListsEdit = () => import('../views/Demo/ListsEdit')
const Templates = () => import('../views/Demo/Templates')
const TemplatesCreate = () => import('../views/Demo/TemplatesCreate')
const TemplatesEdit = () => import('../views/Demo/TemplatesEdit')
const Campaigns = () => import('../views/Demo/Campaigns')
const CampaignsCreate = () => import('../views/Demo/CampaignsCreate')
const CampaignsDetail = () => import('../views/Demo/CampaignsDetail')
const CampaignsEdit = () => import('../views/Demo/CampaignsEdit')
const Leads = () => import('../views/Demo/Leads')
const LeadsDetail = () => import('../views/Demo/LeadsDetail')
const CompanyLeads = () => import('../views/Demo/CompanyLeads')
const CompanyLeadsDetail = () => import('../views/Demo/CompanyLeadsDetail')
const ProductGroups = () => import('../views/Demo/ProductGroups')
const ProductGroupsCreate = () => import('../views/Demo/ProductGroupsCreate')
const ProductGroupsEdit = () => import('../views/Demo/ProductGroupsEdit')
const Users = () => import('../views/Demo/Users')
const UsersCreate = () => import('../views/Demo/UsersCreate')
const UsersEdit = () => import('../views/Demo/UsersEdit')
const UserOrganizations = () => import('../views/Demo/UserOrganizations')
const Organizations = () => import('../views/Demo/Organizations')
const OrganizationsCreate = () => import('../views/Demo/OrganizationsCreate')
const OrganizationsEdit = () => import('../views/Demo/OrganizationsEdit')
const MyOrganization = () => import('../views/Demo/MyOrganization')
const Imports = () => import('../views/Demo/Imports')
const ImportsCreate = () => import('../views/Demo/ImportsCreate')
const ImportsDetail = () => import('../views/Demo/ImportsDetail')
const Exports = () => import('../views/Demo/Exports')
const AnalyticsBusiness = () => import('../views/Demo/AnalyticsBusiness')
const AnalyticsActivity = () => import('../views/Demo/AnalyticsActivity')
const NotFound = () => import('../views/Demo/NotFound.vue')
const Unsubscribe = () => import('../views/Demo/Unsubscribe.vue')
const Domains = () => import('../views/Demo/Domains')
const AIAssistant = () => import('../views/Demo/AIAssistant');
const ProductExpert = () => import('../views/Demo/Components/ProductExpert.vue');
const DataSources = () => import('../views/Demo/DataSources')

import { getAccount } from '../Utils/account';

Vue.use(VueRouter)

const childRoutes = (prop) => [
  {
    path: '/',
    redirect: '/'
  },
  {
    path: 'home-1',
    name: prop + '.home-1',
    meta: { auth: true, name: 'Home 1', layout: 'mini-sidebar-right-fix' },
    component: Dashboard1
  },
  {
    path: 'home-12',
    name: prop + '.home-12',
    meta: { auth: true, name: 'Home 12', layout: 'mini-sidebar-right-fix' },
    component: Dashboard12
  },
  {
    path: 'home-2',
    name: prop + '.home-2',
    meta: { auth: true, name: 'Home 2' },
    component: Dashboard2
  },
  {
    path: 'home-5',
    name: prop + '.home-5',
    meta: { auth: true, name: 'Home 5', layout: 'two-sidebar' },
    component: Dashboard5
  },
  {
    path: 'home-6',
    name: prop + '.home-6',
    meta: { auth: true, name: 'Home 6', layout: 'icon-with-text' },
    component: Dashboard6
  }
]
const horizontalRoute = (prop) => [
  {
    path: 'home-3',
    name: prop + '.home-3',
    meta: { auth: true, name: 'Home 3', layout: 'nav-with-menu' },
    component: Dashboard3
  },
  {
    path: 'home-4',
    name: prop + '.home-4',
    meta: { auth: true, name: 'Home 4', layout: 'nav-bottom-menu' },
    component: Dashboard4
  }
]
const coreChildRoute = (prop) => [
  {
    path: 'ui-colors',
    name: prop + '.color',
    meta: { auth: true, name: 'Colors' },
    component: UiColors
  },
  {
    path: 'ui-typography',
    name: prop + '.typography',
    meta: { auth: true, name: 'Typography' },
    component: UiTypography
  },
  {
    path: 'ui-alerts',
    name: prop + '.alert',
    meta: { auth: true, name: 'Alert' },
    component: UiAlerts
  },
  {
    path: 'ui-buttons',
    name: prop + '.button',
    meta: { auth: true, name: 'Button' },
    component: UiButtons
  },
  {
    path: 'ui-breadcrumb',
    name: prop + '.breadcrumb',
    meta: { auth: true, name: 'Breadcrumb' },
    component: UiBreadcrumb
  },
  {
    path: 'ui-badges',
    name: prop + '.badges',
    meta: { auth: true, name: 'Badges' },
    component: UiBadges
  },
  {
    path: 'ui-cards',
    name: prop + '.cards',
    meta: { auth: true, name: 'Card' },
    component: UiCards
  },
  {
    path: 'ui-carousel',
    name: prop + '.carousel',
    meta: { auth: true, name: 'Carousel' },
    component: UiCarousel
  },
  {
    path: 'ui-grid',
    name: prop + '.grid',
    meta: { auth: true, name: 'Grid' },
    component: UiGrid
  },
  {
    path: 'ui-embed-video',
    name: prop + '.embed-video',
    meta: { auth: true, name: 'Embed Video' },
    component: UiEmbedVideo
  },
  {
    path: 'ui-modal',
    name: prop + '.modal',
    meta: { auth: true, name: 'Model' },
    component: UiModal
  },
  {
    path: 'ui-listgroup',
    name: prop + '.listgroup',
    meta: { auth: true, name: 'List Group' },
    component: UiListGroup
  },
  {
    path: 'ui-images',
    name: prop + '.images',
    meta: { auth: true, name: 'Image' },
    component: UiImages
  },
  {
    path: 'ui-media-object',
    name: prop + '.media-object',
    meta: { auth: true, name: 'Media Object' },
    component: UiMediaObject
  },
  {
    path: 'ui-pagination',
    name: prop + '.pagination',
    meta: { auth: true, name: 'Paginations' },
    component: UiPagination
  },
  {
    path: 'ui-progressbars',
    name: prop + '.progressbars',
    meta: { auth: true, name: 'Progressbar' },
    component: UiProgressBars
  },
  {
    path: 'ui-tooltips',
    name: prop + '.tooltips',
    meta: { auth: true, name: 'Tooltip' },
    component: UiTooltips
  },
  {
    path: 'ui-popovers',
    name: prop + '.popovers',
    meta: { auth: true, name: 'Popover' },
    component: UiPopovers
  },
  {
    path: 'ui-notifications',
    name: prop + '.notifications',
    meta: { auth: true, name: 'Notification' },
    component: UiNotifications
  },
  {
    path: 'ui-tabs',
    name: prop + '.tabs',
    meta: { auth: true, name: 'Tabs' },
    component: UiTabs
  }
]
const formChildRoute = (prop) => [
  {
    path: 'form-layout',
    name: prop + '.layout',
    meta: { auth: true, name: 'Layout' },
    component: FormLayout
  },
  {
    path: 'form-validate',
    name: prop + '.validate',
    meta: { auth: true, name: 'Validate' },
    component: FormValidates
  },
  {
    path: 'form-switches',
    name: prop + '.switch',
    meta: { auth: true, name: 'Switch' },
    component: FormSwitches
  },
  {
    path: 'form-radios',
    name: prop + '.radio',
    meta: { auth: true, name: 'Radio' },
    component: FormRadios
  },
  {
    path: 'form-checkboxes',
    name: prop + '.checkbox',
    meta: { auth: true, name: 'Checkbox' },
    component: FormCheckboxes
  }
]
const tableChildRoute = (prop) => [
  {
    path: 'tables-basic',
    name: prop + '.basic',
    meta: { auth: true, name: 'Basic' },
    component: TablesBasic
  },
  {
    path: 'editable',
    name: prop + '.editable',
    meta: { auth: true, name: 'Editable' },
    component: EditableTable
  }
]
const iconChildRoute = (prop) => [
  {
    path: 'dripicons',
    name: prop + '.dripicons',
    meta: { auth: true, name: 'Dripicons' },
    component: IconDripicons
  },
  {
    path: 'fontawesome-5',
    name: prop + '.fontawesome-5',
    meta: { auth: true, name: 'Font Awsome' },
    component: IconFontawesome5
  },
  {
    path: 'lineawesome',
    name: prop + '.lineawesome',
    meta: { auth: true, name: 'Line Awsome' },
    component: IconLineAwesome
  },
  {
    path: 'remixicon',
    name: prop + '.remixicon',
    meta: { auth: true, name: 'Remixicon' },
    component: IconRemixicon
  },
  {
    path: 'unicons',
    name: prop + '.unicons',
    meta: { auth: true, name: 'Unicon' },
    component: IconUnicons
  }
]
const chartChildRoutes = (prop) => [
  {
    path: 'apex-charts',
    name: prop + '.apex',
    meta: { auth: true, name: 'Apex Chart' },
    component: ApexCharts
  },
  {
    path: 'am-charts',
    name: prop + '.am',
    meta: { auth: true, name: 'Am Chart' },
    component: AmCharts
  },
  {
    path: 'high-charts',
    name: prop + '.high',
    meta: { auth: true, name: 'High Chart' },
    component: HighCharts
  }
]

const appChildRoute = (prop) => [
  {
    path: 'calendar',
    name: prop + '.calendar',
    meta: { auth: true, name: 'Calendar' },
    component: Calendar
  },
  {
    path: 'chat',
    name: prop + '.chat',
    meta: { auth: true, name: 'Chat' },
    component: ChatIndex
  },
  {
    path: 'email',
    name: prop + '.email',
    meta: { auth: true, name: 'Email' },
    component: EmailListing
  },
  {
    path: 'email-compose',
    name: prop + '.email.compose',
    meta: { auth: true, name: 'New Email' },
    component: EmailCompose
  },
  {
    path: 'e-commerce/listing',
    name: prop + '.e-commerce.index',
    meta: { auth: true, name: 'Product list' },
    component: ECommerceListing
  },
  {
    path: 'e-commerce/detail',
    name: prop + '.e-commerce.detail',
    meta: { auth: true, name: 'Product Detail' },
    component: EcommerceDetail
  },
  {
    path: 'e-commerce/checkout',
    name: prop + '.e-commerce.cart',
    meta: { auth: true, name: 'Checkout' },
    component: Checkout
  },
  {
    path: 'e-commerce/wish-list',
    name: prop + '.e-commerce.wishlist',
    meta: { auth: true, name: 'Wishlist' },
    component: Wishlist
  },
  {
    path: 'project-management',
    name: prop + '.project.management',
    meta: { auth: true, name: 'Project Management' },
    component: ProjectBoard
  },
  {
    path: 'todo',
    name: prop + '.todo',
    meta: { auth: true, name: 'Todo' },
    component: TodoListing
  },
  {
    path: 'treeview',
    name: prop + '.treeview',
    meta: { auth: true, name: 'Tree View' },
    component: AppTreeView
  }
]

const authChildRoutes = (prop) => [
  {
    path: 'login',
    name: prop + '.login',
    meta: { auth: false },
    component: Login
  },
  {
    path: 'send-reset-code',
    name: prop + '.send-reset-code',
    meta: { auth: false },
    component: SendResetCode
  },
  {
    path: 'reset-password',
    name: prop + '.password-reset',
    meta: { auth: false },
    component: ResetPassword
  },
  {
    path: 'register',
    name: prop + '.register',
    meta: { auth: false },
    component: Register
  },
  // {
  //   path: 'sign-in1',
  //   name: prop + '.sign-in1',
  //   meta: { auth: true },
  //   component: SignIn1
  // },
  // {
  //   path: 'sign-up1',
  //   name: prop + '.sign-up1',
  //   meta: { auth: false },
  //   component: SignUp1
  // },
  // {
  //   path: 'password-reset1',
  //   name: prop + '.password-reset1',
  //   meta: { auth: true },
  //   component: RecoverPassword1
  // },
  // {
  //   path: 'lock-screen1',
  //   name: prop + '.lock-screen1',
  //   meta: { auth: true },
  //   component: LockScreen1
  // },
  // {
  //   path: 'confirm-mail1',
  //   name: prop + '.confirm-mail1',
  //   meta: { auth: true },
  //   component: ConfirmMail1
  // }
]

const mapChildRoute = (prop) => [
  {
    path: 'google-maps',
    name: prop + '.google',
    meta: { auth: true, name: 'Google map' },
    component: GoogleMaps
  }
]

const defaultlayout = (prop) => [
  {
    path: 'timeline',
    name: prop + '.timeline',
    meta: { auth: true, name: 'Timeline' },
    component: TimeLine
  },
  {
    path: 'invoice',
    name: prop + '.invoice',
    meta: { auth: true, name: 'Invoice' },
    component: Invoice
  },
  {
    path: 'blank-page',
    name: prop + '.blank-page',
    meta: { auth: true, name: 'Blank Page' },
    component: BlankPage
  },
  {
    path: 'pricing',
    name: prop + '.pricing',
    meta: { auth: true, name: 'Pricing' },
    component: Pricing
  },
  {
    path: 'pricing-1',
    name: prop + '.pricing1',
    meta: { auth: true, name: 'Pricing 1' },
    component: Pricing1
  },
  {
    path: 'faq',
    name: prop + '.faq',
    meta: { auth: true, name: 'Faq' },
    component: FAQ
  }
]

const pagesChildRoutes = (prop) => [
  {
    path: 'error/:code',
    name: prop + '.error',
    meta: { auth: true },
    component: ErrorPage
  },
  {
    path: 'coming-soon',
    name: prop + '.coming-soon',
    meta: { auth: true },
    component: ComingSoon
  },
  {
    path: 'maintenance',
    name: prop + '.maintenance',
    meta: { auth: true },
    component: Maintenance
  }
]
const userChildRoute = (prop) => [
  {
    path: 'profile',
    name: prop + '.profile',
    meta: { auth: true, name: 'Profile' },
    component: Profile
  },
  {
    path: 'profile-edit/:id',
    name: prop + '.edit',
    meta: { auth: true, name: 'Edit Profile' },
    component: ProfileEdit
  },
  {
    path: 'add-user',
    name: prop + '.add',
    meta: { auth: true, name: 'Add Profile' },
    component: AddUser
  },
  {
    path: 'user-list',
    name: prop + '.list',
    meta: { auth: true, name: 'User List' },
    component: UserList
  }
]
const socialChildRoute = (prop) => [
  {
    path: 'social',
    name: prop + '.list',
    meta: { auth: true, name: 'Social App' },
    component: SocialApp
  }
]

const pluginsChildRoute = (prop) => [
  {
    path: 'datepicker',
    name: prop + '.datepicker',
    meta: { auth: true, name: 'Datepicker' },
    component: DatepickerDemo
  },
  {
    path: 'select',
    name: prop + '.select',
    meta: { auth: true, name: 'Select' },
    component: SelectDemo
  },
  {
    path: 'draggable',
    name: prop + '.draggable',
    meta: { auth: true, name: 'Draggable' },
    component: DragDropDemo
  }
]
const appRoutes = (prop) => [
  {
    path: '/',
    name: 'dashboard',
    meta: { auth: true, name: 'dashboard' },
    component: Dashboard
  },
  {
    path: 'contacts',
    name: 'contacts',
    meta: { auth: true, name: 'contacts' },
    component: Contacts
  },
  {
    path: 'contacts/create',
    name: 'contacts.create',
    meta: { auth: true, name: 'contacts.create' },
    component: ContactsCreate
  },
  {
    path: 'contacts/:id',
    name: 'contacts.detail',
    meta: { auth: true, name: 'contacts.detail', debug: true },
    component: ContactsDetail
  },
  {
    path: 'contacts/:id/edit',
    name: 'contacts.edit',
    meta: { auth: true, name: 'contacts.edit' },
    component: ContactsEdit
  },
  {
    path: 'companies',
    name: 'companies',
    meta: { auth: true, name: 'companies' },
    component: Companies
  },
  {
    path: 'companies/create',
    name: 'companies.create',
    meta: { auth: true, name: 'companies.create' },
    component: CompaniesCreate
  },
  {
    path: 'companies/:id',
    name: 'companies.detail',
    meta: { auth: true, name: 'companies.detail' },
    component: CompaniesDetail
  },
  {
    path: 'companies/:id/edit',
    name: 'companies.edit',
    meta: { auth: true, name: 'companies.edit' },
    component: CompaniesEdit
  },
  {
    path: 'lists',
    name: 'lists',
    meta: { auth: true, name: 'lists' },
    component: Lists
  },
  {
    path: 'lists/create',
    name: 'lists.create',
    meta: { auth: true, name: 'lists.create' },
    component: ListsCreate
  },
  {
    path: 'lists/:id/edit',
    name: 'lists.edit',
    meta: { auth: true, name: 'lists.edit' },
    component: ListsEdit
  },
  {
    path: 'templates',
    name: 'templates',
    meta: { auth: true, name: 'templates' },
    component: Templates
  },
  {
    path: 'templates/create',
    name: 'templates.create',
    meta: { auth: true, name: 'templates.create' },
    component: TemplatesCreate
  },
  {
    path: 'templates/:id/edit',
    name: 'templates.edit',
    meta: { auth: true, name: 'templates.edit' },
    component: TemplatesEdit
  },
  {
    path: 'campaigns',
    name: 'campaigns',
    meta: { auth: true, name: 'campaigns' },
    component: Campaigns
  },
  {
    path: 'campaigns/create',
    name: 'campaigns.create',
    meta: { auth: true, name: 'campaigns.create' },
    component: CampaignsCreate
  },
  {
    path: 'campaigns/:id',
    name: 'campaigns.detail',
    meta: { auth: true, name: 'campaigns.detail' },
    component: CampaignsDetail
  },
  {
    path: 'campaigns/:id/edit',
    name: 'campaigns.edit',
    meta: { auth: true, name: 'campaigns.edit' },
    component: CampaignsEdit
  },
  {
    path: 'leads',
    name: 'leads',
    meta: { auth: true, name: 'leads', debug: true },
    component: Leads
  },
  {
    path: 'leads/:id',
    name: 'leads.detail',
    meta: { auth: true, name: 'leads.detail', debug: true },
    component: LeadsDetail
  },
  {
    path: 'company-leads',
    name: 'company-leads',
    meta: { auth: true, name: 'company-leads' },
    component: CompanyLeads
  },
  {
    path: 'company-leads/:id',
    name: 'company-leads.detail',
    meta: { auth: true, name: 'company-leads.detail' },
    component: CompanyLeadsDetail
  },
  {
    path: 'product-groups',
    name: 'product-groups',
    meta: { auth: true, name: 'product-groups' },
    component: ProductGroups
  },
  {
    path: 'product-groups/create',
    name: 'product-groups.create',
    meta: { auth: true, name: 'product-groups.create' },
    component: ProductGroupsCreate
  },
  {
    path: 'product-groups/:id/edit',
    name: 'product-groups.edit',
    meta: { auth: true, name: 'product-groups.edit' },
    component: ProductGroupsEdit
  },
  {
    path: 'domains',
    name: 'domains',
    meta: { auth: true, name: 'domains' },
    component: Domains
  },
  {
    path: 'users',
    name: 'users',
    meta: { auth: true, name: 'users' },
    component: Users
  },
  {
    path: 'users/create',
    name: 'users.create',
    meta: { auth: true, name: 'users.create' },
    component: UsersCreate
  },
  {
    path: 'users/:id/edit',
    name: 'users.edit',
    meta: { auth: true, name: 'users.edit' },
    component: UsersEdit
  },
  {
    path: 'user-organizations',
    name: 'user-organizations',
    meta: { auth: true, name: 'user-organizations' },
    component: UserOrganizations
  },
  {
    path: 'organizations/my',
    name: 'organizations.my',
    meta: { auth: true, name: 'organizations.my' },
    component: MyOrganization
  },
  {
    path: 'organizations',
    name: 'organizations',
    meta: { auth: true, name: 'organizations' },
    component: Organizations
  },
  {
    path: 'organizations/create',
    name: 'organizations.create',
    meta: { auth: true, name: 'organizations.create' },
    component: OrganizationsCreate
  },
  {
    path: 'organizations/:id/edit',
    name: 'organizations.edit',
    meta: { auth: true, name: 'organizations.edit' },
    component: OrganizationsEdit
  },
  {
    path: 'imports',
    name: 'imports',
    meta: { auth: true, name: 'imports' },
    component: Imports
  },
  {
    path: 'imports/create',
    name: 'imports.create',
    meta: { auth: true, name: 'imports.create' },
    component: ImportsCreate
  },
  {
    path: 'imports/:id/detail',
    name: 'imports.detail',
    meta: { auth: true, name: 'imports.detail' },
    component: ImportsDetail
  },
  {
    path: 'exports',
    name: 'exports',
    meta: { auth: true, name: 'exports' },
    component: Exports
  },
  {
    path: 'contact-management',
    name: 'contact-management',
    meta: { auth: true, name: 'contact-management' },
    component: ContactManagement
  },
  {
    path: 'analytics/business',
    name: 'analytics.business',
    meta: { auth: true, name: 'analytics.business' },
    component: AnalyticsBusiness
  },
  {
    path: 'analytics/activity',
    name: 'analytics.activity',
    meta: { auth: true, name: 'analytics.activity' },
    component: AnalyticsActivity
  },
  {
    path: 'ai-assistant',
    name: 'ai-assistant',
    meta: { auth: true, name: 'ai-assistant' },
    component: AIAssistant
    
  },
  {
    path: 'product-expert',
    name: 'product-expert',
    meta: { auth: true, name: 'product-expert' },
    component: ProductExpert
  },
  {
    path: 'data-sources',
    name: 'data-sources',
    meta: { auth: true, name: 'data-sources' },
    component: DataSources
  },
]
const routes = [
  {
    path: '/',
    component: VerticalLayout,
    meta: { auth: true },
    children: appRoutes('')
  },
  {
    path: '/unsubscribe',
    name: 'unsubscribe',
    meta: { auth: false, name: 'unsubscribe' },
    component: Unsubscribe
  },
  // {
  //   path: '/',
  //   name: 'dashboard',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: childRoutes('dashboard')
  // },
  // {
  //   path: '/theme',
  //   redirect: '/home-1'
  // },
  // {
  //   path: '/menu-design',
  //   name: 'horizontal-dashboard',
  //   component: HorizantalLayout,
  //   meta: { auth: true },
  //   children: horizontalRoute('dashboard')
  // },
  // {
  //   path: '/core',
  //   name: 'core',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: coreChildRoute('core')
  // },
  // {
  //   path: '/table',
  //   name: 'table',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: tableChildRoute('table')
  // },
  // {
  //   path: '/chart',
  //   name: 'chart',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: chartChildRoutes('chart')
  // },
  // {
  //   path: '/icon',
  //   name: 'icon',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: iconChildRoute('icon')
  // },
  {
    path: '/auth',
    name: 'auth',
    component: AuthLayout,
    meta: { auth: true },
    children: authChildRoutes('auth')
  },
  // {
  //   path: '/pages',
  //   name: 'pages',
  //   component: Default,
  //   meta: { auth: true },
  //   children: pagesChildRoutes('default')
  // },
  // {
  //   path: '/extra-pages',
  //   name: 'extra-pages',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: defaultlayout('extra-pages')
  // },
  // {
  //   path: '/app',
  //   name: 'app',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: appChildRoute('app')
  // },
  // {
  //   path: '/user',
  //   name: 'user',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: userChildRoute('user')
  // },
  // {
  //   path: '/social',
  //   name: 'social',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: socialChildRoute('social')
  // },
  // {
  //   path: '/map',
  //   name: 'map',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: mapChildRoute('map')
  // },
  // {
  //   path: '/form',
  //   name: 'form',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: formChildRoute('form')
  // },
  // {
  //   path: '/plugins',
  //   name: 'plugins',
  //   component: VerticleLayout,
  //   meta: { auth: true },
  //   children: pluginsChildRoute('plugins')
  // },
  // {
  //   path: '/callback',
  //   name: 'callback',
  //   meta: { auth: false },
  //   component: Callback
  // },
  {
    path: '/:pathMatch(.*)*',
    name: 'pagenotfound',
    meta: { auth: false },
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  if (to.meta?.debug === true && isDebug() !== true) {
    next('/not-found')
  }

  // check only auth enabled routes
  if (to.meta?.auth === true) {
    // if not authenticated - error
    if (!isAuthenticated()) {
      next('/auth/login')
    } else {
      // if authenticated get account TODO: add trycatch for cases when something wrong with account occures
      const { allowedRoutes } = await getAccount();
      if (!allowedRoutes.includes(to.name)) {
        // redirect to not allowed page
        next('/not-found')
      } else {
        next()
      }
    }

  } else {
    next()
  }
})

export default router
